export function AnimatedGradientBackground() {
  return (
    <div
      className="animated-gradient-bg fixed inset-0"
      style={{ zIndex: -10 }}
      aria-hidden="true"
    >
      {/* Overlay: when --admin-page-bg is solid (light/dark/custom) it covers the gradient.
          When transparent (glass scheme) the gradient shows through. */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'var(--admin-page-bg)' }}
      />
    </div>
  );
}
